import { produce } from 'immer';

import AuthTypes from './types';

const INITIAL_STATE = {
	usuario: null,
	token: null,
	refreshToken: null,
	isAuthenticated: false,
};

export default function reducer(state = INITIAL_STATE, action) {
	return produce(state, draft => {
		switch (action.type) {
			case AuthTypes.AUTH_SUCCESS:
				draft.usuario = action.payload.usuario;
				draft.token = action.payload.token;
				draft.refreshToken = action.payload.refreshToken
				draft.isAuthenticated = true;
				break;
			case AuthTypes.AUTH_LOGOUT:
				draft.usuario = null;
				draft.token = null;
				draft.refreshToken = null;
				draft.isAuthenticated = false;
				break;
			default:
		}
	});
}